import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=350cfacb&scoped=true&lang=pug&"
import script from "./TransactionsView.vue?vue&type=script&lang=js&"
export * from "./TransactionsView.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsView.vue?vue&type=style&index=0&id=350cfacb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350cfacb",
  null
  
)

export default component.exports